import { cn } from '@/lib/utils';
import { ReactNode, HTMLAttributes } from 'react';

interface GlassCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'floating';
}

const GlassCard = ({ children, className, variant = 'default', ...props }: GlassCardProps) => {
  return (
    <div
      {...props}
      className={cn(
        // Ruhige, leichte Flächen statt schwerer Glas-Optik
        'bg-card/70',
        'border border-border/50',
        'rounded-3xl',
        'shadow-none',
        // Floating-Effekt für liquid glass
        variant === 'floating' && [
          'transition-colors duration-[260ms] ease-out',
        ],
        // Standard-Padding passend zum Design-System
        'p-6 md:p-10 lg:p-14',
        className
      )}
    >
      {children}
    </div>
  );
};

export default GlassCard;

